/** Canonical external links, in one place. */
export const REPO_URL = "https://github.com/makkr-studio/pattern";
export const NPM_URL = "https://www.npmjs.com/package/create-pattern";
export const CREATE_CMD = "npm create pattern@latest";
